export function filterByValue<T extends object>(arr: T[], searchTerm: string): T[] {
  return arr.filter(item =>
    Object.keys(item).some(key => {
      const val = (item as Record<string, unknown>)[key];
      return (
        typeof val === 'string' &&
        val.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
  );
}

export function filterByValues<T>(
  arr: T[],
  filters: { [key: string]: any }
): T[] {
  return arr.filter(item => {
    const row = item as Record<string, unknown>;
    return Object.keys(filters).every((filterName) => row[filterName] === filters[filterName]);
  });
}
